import { ProductMenuComponent } from './product-menu.component';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AbsolutePathModule } from '@app/pipes/absolute-path/absolute-path.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AbsolutePathModule,
    ],
    declarations: [
        ProductMenuComponent,
    ],
    exports: [
        ProductMenuComponent,
    ]
})

export class ProductMenuModule {

}
